import React from 'react';
import { useVideoStore } from '../store/videoStore';

const Timeline = () => {
  const { currentTime, duration, seekTo } = useVideoStore();

  // 处理时间轴点击
  const handleTimelineClick = (e) => {
    if (!duration) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const newTime = percent * duration;
    
    seekTo(newTime);
  };

  // 格式化时间显示
  const formatTime = (time) => {
    if (!time || isNaN(time)) return '00:00.000';
    
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const milliseconds = Math.floor((time % 1) * 1000);
    
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${milliseconds.toString().padStart(3, '0')}`;
  };

  // 生成时间刻度
  const generateTimeMarkers = () => {
    if (!duration) return [];
    
    const markers = [];
    const interval = duration > 300 ? 60 : duration > 60 ? 10 : 5; // 根据总时长调整间隔
    
    for (let time = 0; time <= duration; time += interval) {
      const percent = (time / duration) * 100;
      markers.push(
        <div
          key={time}
          className="time-marker"
          style={{ left: `${percent}%` }}
        >
          <div className="marker-line" />
          <div className="marker-text">{formatTime(time)}</div>
        </div>
      );
    }
    
    return markers;
  };

  if (!duration) {
    return (
      <div className="timeline-container">
        <div className="timeline-placeholder">
          <p>请先加载视频文件</p>
        </div>
      </div>
    );
  }

  return (
    <div className="timeline-container">
      <div className="timeline-header">
        <h3>主时间轴</h3>
        <div className="timeline-info">
          <span>当前时间: {formatTime(currentTime)}</span>
          <span>总时长: {formatTime(duration)}</span>
        </div>
      </div>
      
      <div className="timeline-track" onClick={handleTimelineClick}>
        {/* 时间刻度 */}
        <div className="time-markers">
          {generateTimeMarkers()}
        </div>
        
        {/* 进度条背景 */}
        <div className="timeline-background" />
        
        {/* 播放进度 */}
        <div 
          className="timeline-progress"
          style={{ width: `${(currentTime / duration) * 100}%` }}
        />
        
        {/* 播放头 */}
        <div 
          className="timeline-playhead"
          style={{ left: `${(currentTime / duration) * 100}%` }}
        >
          <div className="playhead-line" />
          <div className="playhead-handle" />
        </div>
      </div>
      
      {/* 时间显示 */}
      <div className="timeline-time-display">
        <span className="current-time">{formatTime(currentTime)}</span>
        <span className="separator">/</span>
        <span className="total-time">{formatTime(duration)}</span>
      </div>
    </div>
  );
};

export default Timeline;